function LearningObject (
    Title,
    Href,
    Parameters,
    DataFromLms,
    MasteryScore,
    MaxTimeAllowed,
    TimeLimitAction,
    Prerequisites,
    Visible,
    CompletedByMeasure,
    CompletionThreshold,
    CompletionProgressWeight,
    PersistState,
    ItemIdentifier,
    ResourceIdentifier,
    ExternalIdentifier,
    DatabaseIdentifier,
    ScormType,
    SSPBuckets,
    SequencingData,
    SharedDataMaps,
    Children
) {
    this.Title = Title;
    this.Href = Href;
    this.Parameters = Parameters;
    this.DataFromLms = DataFromLms;
    this.MasteryScore = MasteryScore;
    this.MaxTimeAllowed = MaxTimeAllowed;
    this.TimeLimitAction = TimeLimitAction;
    this.Prerequisites = Prerequisites;
    this.Visible = Visible;
    this.CompletedByMeasure = CompletedByMeasure;
    this.CompletionThreshold = CompletionThreshold;
    this.CompletionProgressWeight = CompletionProgressWeight;
    this.PersistState = PersistState;
    this.ItemIdentifier = ItemIdentifier;
    this.ResourceIdentifier = ResourceIdentifier;
    this.ExternalIdentifier = ExternalIdentifier;
    this.DatabaseIdentifier = DatabaseIdentifier;
    this.ScormType = ScormType;
    this.SSPBuckets = SSPBuckets;
    this.SequencingData = SequencingData;
    this.SharedDataMaps = SharedDataMaps;
    this.Children = Children;

    //
    // flag to indicate that this activity has had the default rollup rules applied to it.
    // flag helps us present more informative debug logs needs to be on learning object
    // instead of activity because these rules get added to the learning object (which isn't
    // cloned) by the look ahead sequencer
    //
    this.UsesDefaultSatisfactionRollupRules = false;
    this.UsesDefaultCompletionRollupRules = false;
}

LearningObject.prototype = {
    GetScaledPassingScore: function () {
        // if there is sequencing data and there is a primary objective
        if (this.SequencingData !== null && this.SequencingData.PrimaryObjective !== null) {
            // if satisfied by measure is true (and not null...implicit in "==true" affirmation)
            if (this.SequencingData.PrimaryObjective.SatisfiedByMeasure === true) {
                // if there is a min normalized measure
                if (this.SequencingData.PrimaryObjective.MinNormalizedMeasure !== null) {
                    // return min normalzied measure
                    return this.SequencingData.PrimaryObjective.MinNormalizedMeasure;
                }

                // return 1.0
                return 1;
            }
        }

        // return unknown
        return null;
    }
};
